import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import MoodOutlinedIcon from "@mui/icons-material/MoodOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

// constant
const icons = {
  BusinessCenterOutlinedIcon,
  PersonAddAltIcon,
  PeopleOutlinedIcon,
  AccountCircleOutlinedIcon,
  CorporateFareOutlinedIcon,
  ExtensionOutlinedIcon,
  MoodOutlinedIcon,
  ConfirmationNumberOutlinedIcon,
  LabelOutlinedIcon,
  DescriptionOutlinedIcon
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const pages = {
  id: "pages",
  title: "pages",
  type: "group",
  children: [
    {
      id: "internal-application",
      title: "Internal App",
      type: "item",
      url: "/pages/internal-application",
      icon: icons.ExtensionOutlinedIcon,
      breadcrumbs: false,
      guardName: "InternalApplicationAdmin"
    },
    {
      id: "tickets",
      title: "Tickets",
      type: "item",
      url: "pages/tickets",
      icon: icons.ConfirmationNumberOutlinedIcon,
      breadcrumbs: false,
      guardName: "Tickets"
    },
    {
      id: "mood-monitor",
      title: "Mood Monitor",
      type: "item",
      url: "/pages/mood-monitor",
      icon: icons.MoodOutlinedIcon,
      breadcrumbs: false,
      guardName: "MoodAdmin"
    },
    {
      id: "document",
      title: "Documents",
      type: "item",
      url: "/pages/document",
      icon: icons.BusinessCenterOutlinedIcon,
      breadcrumbs: false,
      guardName: "DocumentAdmin"
    },
    {
      id: "acknowledgement-request",
      title: "All Document Requests",
      type: "item",
      url: "/pages/acknowledgement-request",
      icon: icons.PersonAddAltIcon,
      breadcrumbs: false,
      guardName: "DocumentAcknowledgementRequestAdmin"
    },
    {
      id: "all-employee",
      title: "All Employee ",
      type: "item",
      url: "/pages/all-employee",
      icon: icons.PeopleOutlinedIcon,
      breadcumbs: false,
      guardName: "AllEmployee"
    },

    {
      id: "departments",
      title: "Departments",
      type: "item",
      url: "/pages/departments",
      icon: icons.CorporateFareOutlinedIcon,
      breadcrumbs: false,
      guardName: "Departments"
    },
    {
      id: "designations",
      title: "Designations",
      type: "item",
      url: "/pages/designations",
      icon: icons.LabelOutlinedIcon,
      breadcrumbs: false,
      guardName: "Designations"
    },
    {
      id: "document-acknowledgement-request-for-me",
      title: "Request For Me",
      type: "item",
      url: "/pages/document-acknowledgement-request-for-me",
      icon: icons.AccountCircleOutlinedIcon,
      breadcrumbs: false,
      guardName: "RequestForMe"
    },
    {
      id: "financial-report",
      title: "Financial Report",
      type: "item",
      url: "/pages/financial-report",
      icon: icons.DescriptionOutlinedIcon,
      breadcrumbs: false,
      guardName: "FinancialReport"
    }
  ]
  //   userid:'pages',
  //     usertype: 'user',
  //     child: [
  //         {
  //             id: 'document-acknowledgement-request-for-me',
  //             title: 'Request For Me',
  //             type: 'item',
  //             url: '/pages/document-acknowledgement-request-for-me',
  //             icon: icons.AccountCircleOutlinedIcon,
  //             breadcrumbs: false
  //         },
  //     ]
};

// const item = utilities?.children

export default pages;
